import { Tab } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';
import { ClassDivisionsClassesTable } from '../../../components/ClassDivisions/ClassDivisionsClassesTable';
import { Page } from '../../../components/Page/Page';
import { usePermissionChecker } from '../../../hooks/usePermissionChecker';
import { SettingsClassesPage } from './Classes/SettingsClassesPage';

export const SetupClassesAndDivisions = () => {
  const { t } = useTranslation();
  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canManageSettings()}>
      <Tab
        variant={'large'}
        tabs={[
          {
            title: t('classes.title', { count: 2 }),
            value: 'classes',
            content: <SettingsClassesPage />,
          },
          {
            title: t('divisions.title', { count: 2 }),
            value: 'divisions',
            content: <ClassDivisionsClassesTable key={'divisions'} />,
          },
        ]}
      />
    </Page>
  );
};
